import { EClientPath } from '~/models/api'

export type TCustomOAuthState = {
  signInRedirectPath: EClientPath
}

export type TNavigateState = {
  isPartnerThemed?: boolean
  validatedUserErrorMessage?: boolean
}

export enum ECognitoGroups {
  admin = 'admin',
  adminLimited = 'adminLimited',
  customerBasicPlan = 'customerBasicPlan',
  customerFreePlan = 'customerFreePlan',
  customerPlusPlan = 'customerPlusPlan',
  customerBasicFreeTrialPlan = 'customerBasicFreeTrialPlan',
}

export const userTiersByPrecedence: { [x in ECognitoGroups]?: number } = {
  [ECognitoGroups.customerFreePlan]: 0,
  [ECognitoGroups.customerBasicPlan]: 1,
  [ECognitoGroups.customerBasicFreeTrialPlan]: 1,
  [ECognitoGroups.customerPlusPlan]: 2,
}

export enum EAuthErrorName {
  CodeMismatchException = 'CodeMismatchException',
  ExpiredCodeException = 'ExpiredCodeException',
  UserNotConfirmedException = 'UserNotConfirmedException',
  UserNotFoundException = 'UserNotFoundException',
}

export enum EFeatureCode {
  customerBasicPlan = 'customerBasicPlan',
  customerPlusPlan = 'customerPlusPlan',
  aiGrowthEngine = 'aiGrowthEngine',
  voip = 'voip',
}
